module.exports = __webpack_public_path__ + "img/znlb_framework_Image .55bf8ff8.png";